import React from 'react'

import ColourIndicator from '../../../../pages/Settings/Controls/Edit/ColourIndicator'

import useStyles from './style'

type TaskStatusProps = {
  opt: Partial<TaskStatus>
  testId?: string
}

const TaskStatus: React.FC<TaskStatusProps> = ({ opt, testId = 'status' }) => {
  const classes = useStyles({ colour: opt.colour })

  return (
    <div className={classes.root}>
      <ColourIndicator colour={opt.colour} />

      <div data-testid={`task-${testId}`} className={classes.truncate}>
        {opt.name ?? 'Unassigned'}
      </div>
    </div>
  )
}

export default React.memo(TaskStatus)
